import React from "react";
import Particles from "@/components/Particles";

// Interactive "network of connections" motif reused across sections.
// Nodes light up and link to the cursor on hover — consistent with the Hero.
export default function ConnectionMotif({ density = 30, className = "" }) {
  return (
    <div className={`pointer-events-none absolute inset-0 ${className}`} aria-hidden="true">
      <Particles density={density} interactive />
    </div>
  );
}
